import React, {useEffect, useRef, useState} from 'react';
import BlackArea from "./BlackArea";
import classes from "./App.module.css";
import {Timer} from "./Timer";
import {ReadyArea} from "./ReadyArea";
import {ResultArea} from "./ResultArea";
import {Anmika} from "./Anmika";
import {BurgerMenu} from "./BurgerMenu";
import {PrivacyPolicyModal} from "./components/PrivacyPolicyModal";
import {TermsOfUseModal} from "./components/TermsOfUseModal";

export type AppStatus = "ready" | "run" | "waitingResult" | "result"

const App = () => {

    const twitText = () => {
        const text = "黒って300色あんねん！探してみー！%0A"
        const tag = "black300,TeamFerrets"
        const url = "https://black-300.com%0A%0A";

        if (text.length > 140) {
            alert("テキストが140字を超えています");
        } else {
            const apiUrl = `http://twitter.com/intent/tweet?url=${url}&hashtags=${tag}&text=${text}`
            return apiUrl
        }
    }

    const [targetColor, setTargetColor] = useState<number[] | undefined>(undefined)
    const [clickCount, setClickCount] = useState<number>(0)
    const [appStatus, setAppStatus] = useState<AppStatus>("ready")

    const countRef = useRef<HTMLDivElement>(null)
    const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false)
    const [isTermsOfUseModal, setIsTermsOfUseModal] = useState(false)


    const colorRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (targetColor !== undefined && colorRef.current !== null) {
            colorRef.current.style.backgroundColor = `rgb(${targetColor[0]},${targetColor[1]},${targetColor[2]})`
        }
    }, [targetColor])


    const tryCountUp = () => {
        setClickCount((clickCount) => {
            return ++clickCount
        })
    }

    const createColorCode = (color: number[]): string => {
        const colorStr: string = String(color)
        const rgbList = colorStr.split(",");

        let r = parseInt(rgbList[0]).toString(16)
        let g = parseInt(rgbList[1]).toString(16)
        let b = parseInt(rgbList[2]).toString(16)

        if (r.length === 1) r = "0" + r
        if (g.length === 1) g = "0" + g
        if (b.length === 1) b = "0" + b

        const colorCode = `#${r}${g}${b}`
        return colorCode
    }

    const isSmartPhone = () => {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    }


    return (
        <>
            <header>
                <h1>
                    <p className={classes.title}>Black300</p>
                </h1>

                <div className={classes.targetArea}>
                    <div id="problem_text" className={classes.targetTextArea}>
                        <div>{appStatus === "ready" ? "真の黒を探せ！" : "この黒を探せ！"}</div>
                        {targetColor !== undefined &&
                            <div>{createColorCode(targetColor)}</div>
                        }
                    </div>
                    <div className={classes.targetColor} ref={colorRef}></div>
                </div>
                <div className={classes.spacer}></div>
                {!isSmartPhone() &&
                    <>
                        <div className={classes.infoArea}>
                            <div className={classes.countTextArea}>
                                <div>
                                    <div>挑戦回数</div>
                                    <div ref={countRef} className={classes.tryCount} id="try">{clickCount} 回</div>
                                </div>
                            </div>
                        </div>
                        <Timer appStatus={appStatus} setClickCount={(count) => setClickCount(count)} countRef={countRef}/>
                    </>
                }
                {isSmartPhone() ? <div></div> :
                    <a className={classes.twitterShareIcon} href={twitText()} target="_blank" rel="noreferrer">Xで<br/>シェア</a>
                }            </header>
            <BurgerMenu pageWrapId="threeFiberArea" outerContainerId="appPage" setIsPrivacyPolicyModal={setIsPrivacyPolicyModal}
                        setIsTermsOfUseModal={setIsTermsOfUseModal}/>

            {appStatus === "ready" && <ReadyArea setAppStatus={(appStatus: AppStatus) => setAppStatus(appStatus)}/>}

            {(appStatus === "run" || appStatus === "waitingResult") &&
                <BlackArea setTargetColor={(red, green, blue) => setTargetColor([red, green, blue])}
                           tryCountUp={tryCountUp}
                           targetColor={targetColor}
                           setAppStatus={(appStatus: AppStatus) => setAppStatus(appStatus)}
                />}
            {appStatus === "result" && <ResultArea setAppStatus={(appStatus: AppStatus) => setAppStatus(appStatus)}/>}

            {isSmartPhone() &&
                <footer className={classes.footer}>
                    <Timer appStatus={appStatus} setClickCount={(count) => setClickCount(count)} countRef={countRef}/>
                    <div className={classes.countTextArea}>
                        <div>
                            <div>挑戦回数</div>
                            <div ref={countRef} className={classes.tryCount} id="try">{clickCount} 回</div>
                        </div>
                    </div>
                </footer>
            }
            <Anmika/>
            {isPrivacyPolicyModal &&
                <PrivacyPolicyModal setIsPrivacyPolicyModal={setIsPrivacyPolicyModal} />
            }
            {isTermsOfUseModal &&
                <TermsOfUseModal setIsTermsOfUseModal={setIsTermsOfUseModal}  />
            }
        </>)
}

export default App;
